import { type Blocker, useBlocker } from 'react-router'
import { useCallback, useEffect } from 'react'

export function useBlockerAndUnload(props: {
  isExistChanges: boolean
  handleShowBlockerModal: (blocker: Blocker) => void
}) {
  const { isExistChanges, handleShowBlockerModal } = props
  const blocker = useBlocker(() => isExistChanges)

  const beforeUnloadHandler = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault()
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [])

  useEffect(() => {
    if (blocker.state === 'blocked') {
      handleShowBlockerModal(blocker)
    }
  }, [blocker])

  useEffect(() => {
    if (isExistChanges) {
      window.addEventListener('beforeunload', beforeUnloadHandler)
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [isExistChanges])
  return { blocker }
}
